import { Link,useNavigate } from "react-router-dom";
// ContactFormHeader component for displaying a header with navigation and buttons
const EmailHeader = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  return (
    <nav className='navbar navbar-expand flex-column flex-md-row bottom-header-main  px-lg-5 px-2 py-2'>
      <div className=' d-flex align-items-center d-md-flex ms-md-2'>
        <div className='d-flex align-items-center bottom-header'>
          {/* Back arrow icon */}
          {/* <div className='icon'>
          <MdKeyboardArrowLeft />
        </div> */}
          {/* ====== Hamburger Button to Toggle The side Bar =========== */}
          <button
            className='sidebar-toggler flex-shrink-0 bg-transparent border-0 me-3'
            onClick={() => navigate(-1)}>
            <i className='fa fa-arrow-left' />
          </button>

          <Link to='/templates'>
            {/* Title */}
            <h5 className='untitled-product-title'>Untitled Product</h5>
            {/* Folder icon and preview text */}
            <p className='d-flex align-items-center'>
              <i className='far fa-folder'></i>
              <span className='preview-text'>Templates</span>
            </p>
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default EmailHeader;
